import http from "../base";
import PresisiteAPIParams from "../persisits/lunch_params";
import {
  LOGIN_WITH_TWO_FACTORURL,
  SEND_TWOFACTOR_LOGINSMS_URL
} from "../constants/path";
import {
  INS_API_TWO_FACTOR_LOGIN,
  INS_API_SEND_TWO_FACTOR_LOGIN_SMS
} from "../constants/event_consts";
import { cg_api_signed_body, creatUUid, handleIgHeaders } from "../utils";
import { mobileconfig } from "./ins_lunch";
let twoFactorWaterfallId = "";
export const twoFactorLogin = async (code: string, twoFactorInfo: any) => {
  const body: Record<string, any> = {};
  body.verification_method = code.length === 8 ? "2" : "1";
  body.verification_code = code;
  body.username = twoFactorInfo && twoFactorInfo.username;
  body.two_factor_identifier =
    twoFactorInfo && twoFactorInfo.two_factor_identifier;
  body.waterfall_id = twoFactorWaterfallId
    ? twoFactorWaterfallId
    : creatUUid()
        .replace("-", "")
        .toLowerCase();
  const trusted_notification_polling_nonce =
    twoFactorInfo.trusted_notification_polling_nonce;
  if (trusted_notification_polling_nonce) {
    body.trusted_notification_polling_nonces = [
      trusted_notification_polling_nonce
    ];
  } else {
    body.trusted_notification_polling_nonces = "[]";
  }
  body.device_id = await PresisiteAPIParams.getAPIId("cg_api_device_id");
  body.phone_id = await PresisiteAPIParams.getAPIId("cg_api_family_device_id");
  body.adid = await PresisiteAPIParams.getAPIId("cg_api_ad_id");
  body.trust_this_device = "1";
  body.att_permission_status = "2";
  body.has_seen_aart_on = "0";

  try {
    const { data, headers } = await http.post(
      LOGIN_WITH_TWO_FACTORURL,
      { data: cg_api_signed_body(body) },
      { return_headers: true },
      INS_API_TWO_FACTOR_LOGIN
    );
    console.log("twoFactorLogin data", data, "headers", headers);
    const userId = data && data.logged_in_user && data.logged_in_user.pk;
    if (userId) {
      handleIgHeaders(headers, userId);
      await mobileconfig(userId);
    }
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const sendTwoFactorLoginSms = async (twoFactorInfo: any) => {
  const body: Record<string, string> = {};
  body.username = twoFactorInfo && twoFactorInfo.username;
  body.two_factor_identifier =
    twoFactorInfo && twoFactorInfo.two_factor_identifier;
  twoFactorWaterfallId = "";
  const waterfallId = twoFactorWaterfallId
    ? twoFactorWaterfallId
    : creatUUid()
        .replace("-", "")
        .toLowerCase();
  body.waterfall_id = waterfallId;
  body.device_id = await PresisiteAPIParams.getAPIId("cg_api_device_id");

  try {
    const result = await http.post(
      SEND_TWOFACTOR_LOGINSMS_URL,
      {
        data: cg_api_signed_body(body)
      },
      {},
      INS_API_SEND_TWO_FACTOR_LOGIN_SMS
    );
    console.log("sendTwoFactorLoginSms result", result);
    twoFactorWaterfallId = waterfallId;
    return result;
  } catch (error) {
    console.log("sendTwoFactorLoginSms error", error);
    return Promise.reject(error);
  }
};
